export const SAVE_ALL_INFRACTIONS = 'SAVE_ALL_INFRACTIONS'